import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Link } from "@opensea/next-ui-kit";
import { Chip } from "@opensea/ui-kit";
import { toLowerCase } from "@opensea/utils";
import { useCategoryEnumName } from "@/hooks/use-enum-name";
export const CollectionCategoryChipFragment = graphql(`
  fragment CollectionCategoryChip on Collection {
    category
  }
`);
export function CollectionCategoryChip(t0) {
  const $ = _c(7);
  let collectionKey;
  let rest;
  if ($[0] !== t0) {
    ({
      collection: collectionKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = collectionKey;
    $[2] = rest;
  } else {
    collectionKey = $[1];
    rest = $[2];
  }
  const collection = readFragment(CollectionCategoryChipFragment, collectionKey);
  const categoryEnumName = useCategoryEnumName();
  if (!collection.category) {
    return;
  }
  const T0 = Chip;
  const t1 = categoryEnumName(collection.category);
  let t2;
  if ($[3] !== T0 || $[4] !== rest || $[5] !== t1) {
    t2 = <T0 {...rest}>{t1}</T0>;
    $[3] = T0;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return <Link href={{
    pathname: "/stats",
    query: {
      category: toLowerCase(collection.category)
    }
  }} variant="unstyled">{t2}</Link>;
}